"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CabucStatusInfo = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Button_1 = require("@skbkontur/react-ui/components/Button");

var Tooltip_1 = require("@skbkontur/react-ui/components/Tooltip");

var Link_1 = require("@skbkontur/react-ui/components/Link");

var HelpDot_1 = tslib_1.__importDefault(require("@skbkontur/react-icons/HelpDot"));

var HelpBook_1 = tslib_1.__importDefault(require("@skbkontur/react-icons/HelpBook"));

var Errors_1 = require("@skbkontur/plugin-js/lib/common/Errors");

var shared_1 = require("../../../shared");

var Errors_2 = require("../../Errors");

var CabucStatusInfo_module_css_1 = tslib_1.__importDefault(require("./CabucStatusInfo.module.css"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var configuration_1 = require("../../../contexts/configuration");

var common_1 = require("../../../utils/common");

var CabucStatusInfo =
/** @class */
function (_super) {
  tslib_1.__extends(CabucStatusInfo, _super);

  function CabucStatusInfo(props) {
    var _this = _super.call(this, props) || this; // Редиректим в Геракл платные сертификаты


    _this.heraclesProcessCert = function () {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var _a, item, CAParams, error_1, url;

        return tslib_1.__generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props, item = _a.item, CAParams = _a.CAParams;
              this.setState({
                loading: true
              });
              if (!CAParams.doBeforeCertificateUpdate) return [3
              /*break*/
              , 4];
              _b.label = 1;

            case 1:
              _b.trys.push([1, 3,, 4]);

              return [4
              /*yield*/
              , CAParams.doBeforeCertificateUpdate(item)];

            case 2:
              _b.sent();

              return [3
              /*break*/
              , 4];

            case 3:
              error_1 = _b.sent(); // все ошибки возникшие в doBeforeCertificateUpdate завершают обновление сертификата

              this.setState({
                loading: false
              });
              return [2
              /*return*/
              ];

            case 4:
              url = CAParams.heraclesProlongationUrl.replace('{{thumbprint}}', item.certificate.thumbprint());
              window.location.assign(url);
              this.setState({
                loading: false
              });
              return [2
              /*return*/
              ];
          }
        });
      });
    }; // Редиректим в Геракл бесплатные сертификаты


    _this.heraclesProcessFreeCert = function () {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var _a, item, CAParams, error_2, url;

        return tslib_1.__generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props, item = _a.item, CAParams = _a.CAParams;
              this.setState({
                loading: true
              });
              if (!CAParams.doBeforeCertificateUpdate) return [3
              /*break*/
              , 4];
              _b.label = 1;

            case 1:
              _b.trys.push([1, 3,, 4]);

              return [4
              /*yield*/
              , CAParams.doBeforeCertificateUpdate(item)];

            case 2:
              _b.sent();

              return [3
              /*break*/
              , 4];

            case 3:
              error_2 = _b.sent();
              this.setState({
                loading: false
              }); // все ошибки возникшие в doBeforeCertificateUpdate завершают обновление сертификата

              return [2
              /*return*/
              ];

            case 4:
              url = CAParams.heraclesFreeProlongationUrl.replace('{{thumbprint}}', item.certificate.thumbprint());
              window.location.assign(url);
              this.setState({
                loading: false
              });
              return [2
              /*return*/
              ];
          }
        });
      });
    }; // Редиректим в ARM платные сертификаты


    _this.KStoreProcessCert = function () {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var _a, item, CAParams, error_3, url;

        return tslib_1.__generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props, item = _a.item, CAParams = _a.CAParams;
              this.setState({
                loading: true
              });
              if (!CAParams.doBeforeCertificateUpdate) return [3
              /*break*/
              , 4];
              _b.label = 1;

            case 1:
              _b.trys.push([1, 3,, 4]);

              return [4
              /*yield*/
              , CAParams.doBeforeCertificateUpdate(item)];

            case 2:
              _b.sent();

              return [3
              /*break*/
              , 4];

            case 3:
              error_3 = _b.sent(); // все ошибки возникшие в doBeforeCertificateUpdate завершают обновление сертификата

              this.setState({
                loading: false
              });
              return [2
              /*return*/
              ];

            case 4:
              url = CAParams.heraclesARMRedirectUrl.replace('{{thumbprint}}', item.certificate.thumbprint());
              window.location.assign(url);
              this.setState({
                loading: false
              });
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.HeraclesKStoreProlongation = function () {
      var item = _this.props.item;

      var onClick = function onClick() {
        _this.context.trackEvent('certificateAction', 'KStoreUpdate', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.KStoreProcessCert();
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.red)
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: _this.state.loading,
        onClick: onClick
      }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435")));
    };

    _this.HeraclesNeedNewCertificate = function () {
      var item = _this.props.item;

      var onClick = function onClick() {
        _this.context.trackEvent('certificateAction', 'heraclesUpdate', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.heraclesProcessCert();
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.red)
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: _this.state.loading,
        onClick: onClick
      }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435")));
    };
    /**
     * Инициируем обновление бесплатных сертификатов через Геракл.
     */


    _this.HeraclesFreeProlongation = function () {
      var item = _this.props.item;

      var onClick = function onClick() {
        return tslib_1.__awaiter(_this, void 0, void 0, function () {
          return tslib_1.__generator(this, function (_a) {
            this.context.trackEvent('certificateAction', 'heraclesFreeUpdate', {
              thumbprint: item.certificate.thumbprint()
            });
            this.heraclesProcessFreeCert();
            return [2
            /*return*/
            ];
          });
        });
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.red)
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: _this.state.loading,
        onClick: onClick
      }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435")));
    };

    _this.HeraclesReissueActiveCert = function () {
      var item = _this.props.item;

      var onClick = function onClick() {
        _this.context.trackEvent('certificateAction', 'heraclesReissueActiveCert', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.heraclesProcessCert();
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.message
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.gray
      }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0432 \u0415\u0413\u0420\u042E\u041B/\u0415\u0413\u0420\u0418\u041F \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442 \u0441\xA0\u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u043F\u043E\xA0\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0443. \u041D\u0443\u0436\u043D\u043E \u043F\u0435\u0440\u0435\u0432\u044B\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442.")), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: _this.state.loading,
        onClick: onClick
      }, "\u041F\u0435\u0440\u0435\u0432\u044B\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442")));
    };

    _this.HeraclesReissueExternalCACert = function () {
      var _a = _this.props,
          item = _a.item,
          CAParams = _a.CAParams;

      var onClick = function onClick() {
        _this.context.trackEvent('certificateAction', 'heraclesReissueExternalCACert', {
          thumbprint: item.certificate.thumbprint()
        });

        var url = CAParams.heraclesExternalCACertReissueUrl.replace('{{thumbprint}}', item.certificate.thumbprint());
        window.location.assign(url);
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.message
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.red)
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item))), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: _this.state.loading,
        onClick: onClick
      }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442")));
    };

    _this.HeraclesReadyForRequestGeneration = function () {
      var item = _this.props.item;

      var onClick = function onClick() {
        _this.context.trackEvent('certificateAction', 'heraclesRequest', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.heraclesProcessCert();
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.message
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.gray
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.green
      }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043F\u0440\u0438\u043D\u044F\u0442\u0430")), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: _this.state.loading,
        onClick: onClick
      }, "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442")));
    };

    _this.HeraclesReleased = function () {
      var item = _this.props.item;

      var onClick = function onClick() {
        _this.context.trackEvent('certificateAction', 'heraclesInstall', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.heraclesProcessCert();
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.message
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.gray
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.green
      }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u0430")), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: _this.state.loading,
        onClick: onClick
      }, "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442")));
    };

    _this.HeraclesErrorInVCR = function () {
      var item = _this.props.item;

      var onClick = function onClick() {
        _this.context.trackEvent('certificateAction', 'heraclesFixErrors', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.heraclesProcessCert();
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.message
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.gray
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.red
      }, "\u0412 \u0437\u0430\u044F\u0432\u043A\u0435 \u0435\u0441\u0442\u044C \u043E\u0448\u0438\u0431\u043A\u0438, \u0437\u0430\u044F\u0432\u043A\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430")), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: _this.state.loading,
        onClick: onClick
      }, "\u0418\u0441\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043E\u0448\u0438\u0431\u043A\u0438")));
    };

    _this.HeraclesContinueUpdate = function () {
      var item = _this.props.item;

      var onClick = function onClick() {
        _this.context.trackEvent('certificateAction', 'heraclesContinueUpdate', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.heraclesProcessCert();
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.message
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.gray
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item))), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: _this.state.loading,
        onClick: onClick
      }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430")));
    };

    _this.HeraclesFinishUpdate = function () {
      var item = _this.props.item;

      var onClick = function onClick() {
        _this.context.trackEvent('certificateAction', 'heraclesFinishUpdate', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.heraclesProcessCert();
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.message
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.gray
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item))), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: _this.state.loading,
        onClick: onClick
      }, "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430")));
    };
    /**
     * Перевыпуск сертификатов на ГОСТ 2012 через СЦ
     * Для тех сертов, которые нельзя перевыпустить через Геракл.
     */


    _this.HeraclesReissueCertWithServiceCenterIn2020 = function () {
      var phone = _this.state.phone ? " " + _this.state.phone : '';
      var _a = _this.props,
          item = _a.item,
          CAParams = _a.CAParams;

      var onWhyReissueLinkClick = function onWhyReissueLinkClick() {
        _this.context.trackEvent('reissueCertWithServiceCenter', 'whyReissueInLinkClick', {
          thumbprint: item.certificate.thumbprint()
        });
      };

      return react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.pad, CabucStatusInfo_module_css_1.default.longText)
      }, react_1.default.createElement("p", null, "\u0421 1 \u044F\u043D\u0432\u0430\u0440\u044F 2020 \u0433\u043E\u0434\u0430 \u0432\u0430\u0448 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u0443\u0442\u0440\u0430\u0442\u0438\u043B \u0441\u0442\u0430\u0442\u0443\u0441 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E. \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u043F\u043E\xA0\u0413\u041E\u0421\u0422\xA02012 \u0447\u0435\u0440\u0435\u0437 \u0441\u0432\u043E\u0439 \u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440", phone, "."), react_1.default.createElement(Link_1.Link, {
        onClick: onWhyReissueLinkClick,
        href: CAParams.whyReissueCertOnGost2012In2020Link,
        target: "_blank"
      }, react_1.default.createElement(HelpBook_1.default, null), "\xA0\u0417\u0430\u0447\u0435\u043C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442"));
    };
    /**
     * Основной способ перевыпуска сертификата.
     * Через Геракл, используя методы Биллинга.
     */


    _this.HeraclesReissueCertWithHeraclesIn2020 = function () {
      var _a = _this.props,
          item = _a.item,
          CAParams = _a.CAParams;

      var onClick = function onClick(e) {
        _this.context.trackEvent('certificateAction', 'reissueCertWithHeracles', {
          thumbprint: item.certificate.thumbprint()
        }); // при перевыпуске сертификата через Геракл не нужна портальная аутентификация.
        // поэтому вызывать doBeforeCertificateUpdate не нужно.


        var url = CAParams.heraclesReissueUrl.replace('{{thumbprint}}', item.certificate.thumbprint());
        window.location.assign(url);
      };

      var onWhyReissueLinkClick = function onWhyReissueLinkClick() {
        _this.context.trackEvent('reissueCertWithHeracles', 'whyReissueInLinkClick', {
          thumbprint: item.certificate.thumbprint()
        });
      };

      return react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.pad, CabucStatusInfo_module_css_1.default.longText)
      }, react_1.default.createElement("p", null, "\u0421 1 \u044F\u043D\u0432\u0430\u0440\u044F 2020 \u0433\u043E\u0434\u0430 \u0432\u0430\u0448 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u0443\u0442\u0440\u0430\u0442\u0438\u043B \u0441\u0442\u0430\u0442\u0443\u0441 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E. \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u043F\u043E\xA0\u0413\u041E\u0421\u0422\xA02012."), react_1.default.createElement(Link_1.Link, {
        onClick: onWhyReissueLinkClick,
        href: CAParams.whyReissueCertOnGost2012In2020Link,
        target: "_blank"
      }, react_1.default.createElement(HelpBook_1.default, null), "\xA0\u0417\u0430\u0447\u0435\u043C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442"), react_1.default.createElement("div", {
        style: {
          marginTop: 18
        }
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        onClick: onClick
      }, "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442")));
    };
    /**
     * Инициируем обновление сертификата через методы Клиент-Сервиса.
     * Временно для перевыпуска сертификата на ГОСТ 2012 тоже используется этот метод,
     * во время обработки статуса 141.
     */


    _this.onUpdateCertWithCSClick = function () {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var pluginFullInfo, _a, item, CAParams, plugin, useOldCACabinetVersion, error_4, newFormId, formUrl, e_1, content, searchResults, updateUrl, e_2;

        return tslib_1.__generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              pluginFullInfo = this.context.pluginFullInfo;
              _a = this.props, item = _a.item, CAParams = _a.CAParams;
              plugin = pluginFullInfo ? pluginFullInfo.plugin : undefined;
              this.setState({
                loading: true
              });
              useOldCACabinetVersion = false;
              if (!CAParams.doBeforeCertificateUpdate) return [3
              /*break*/
              , 4];
              _b.label = 1;

            case 1:
              _b.trys.push([1, 3,, 4]);

              return [4
              /*yield*/
              , CAParams.doBeforeCertificateUpdate(item)];

            case 2:
              _b.sent();

              return [3
              /*break*/
              , 4];

            case 3:
              error_4 = _b.sent();

              if (error_4 instanceof Errors_1.CommonError && error_4.code === 'ExpiredCertificate') {
                useOldCACabinetVersion = true;
              } else {
                // все другие ошибки возникшие в doBeforeCertificateUpdate завершают обновление сертификата
                this.setState({
                  loading: false
                });
                return [2
                /*return*/
                ];
              }

              return [3
              /*break*/
              , 4];

            case 4:
              newFormId = item.statusInfo.newFormId;
              if (!newFormId) return [3
              /*break*/
              , 8];
              _b.label = 5;

            case 5:
              _b.trys.push([5, 7,, 8]);

              return [4
              /*yield*/
              , CAParams.getUpdateFormUrl(newFormId)];

            case 6:
              formUrl = _b.sent();
              formUrl = this.changeCabucFormUrl(formUrl, useOldCACabinetVersion);
              this.context.trackEvent('useExistingFormId', item.certificate.thumbprint(), {
                formId: newFormId
              });
              window.location.assign(formUrl);
              return [2
              /*return*/
              ];

            case 7:
              e_1 = _b.sent();
              this.setState({
                loading: false
              }); // важно понимать как часто не получается получить форму по FormId который приходит вместе со статусом 1

              this.context.trackEvent('getExistingFormIdUrlError', item.certificate.thumbprint(), {
                formId: newFormId,
                message: e_1.message
              });
              this.processError(e_1);
              return [2
              /*return*/
              ];

            case 8:
              _b.trys.push([8, 12,, 13]);

              content = item.certificate.toBase64();
              if (!(content === '')) return [3
              /*break*/
              , 10];
              return [4
              /*yield*/
              , plugin.searchCertificate({
                store: {
                  name: item.storeInfo.name
                },
                hash: item.certificate.thumbprint()
              }, {
                content: true,
                serialNumber: false,
                issuer: false,
                subject: false,
                validFrom: false,
                validTo: false,
                hasPrivateKey: false,
                qualified: false,
                extensions: false,
                cryptoProvider: false,
                containerInfo: false
              })];

            case 9:
              searchResults = _b.sent();

              if (searchResults.length === 0) {
                throw new Errors_1.CommonError('Certificate was not found', null, Errors_2.ErrorCodes.CertificateNotFound);
              }

              content = searchResults[0].toBase64();
              _b.label = 10;

            case 10:
              return [4
              /*yield*/
              , CAParams.getUpdateUrl(item.certificate.thumbprint(), content)];

            case 11:
              updateUrl = _b.sent();
              updateUrl = this.changeCabucFormUrl(updateUrl, useOldCACabinetVersion);
              window.location.assign(updateUrl);
              return [3
              /*break*/
              , 13];

            case 12:
              e_2 = _b.sent(); // убираем загрузку если произошла ошибка. Например getUpdateUrl зареджектился.

              this.setState({
                loading: false
              });
              this.processError(e_2);
              return [3
              /*break*/
              , 13];

            case 13:
              return [2
              /*return*/
              ];
          }
        });
      });
    };
    /**
     * Временный перевыпуск сертификата через Клиент-Сервис.
     */


    _this.HeraclesReissueCertWithCSIn2020 = function () {
      var _a = _this.props,
          item = _a.item,
          CAParams = _a.CAParams;
      var loading = _this.state.loading;

      var onClick = function onClick(e) {
        _this.context.trackEvent('certificateAction', 'reissueCertWithCS', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.onUpdateCertWithCSClick();
      };

      var onWhyReissueLinkClick = function onWhyReissueLinkClick() {
        _this.context.trackEvent('reissueCertWithCS', 'whyReissueLinkClick', {
          thumbprint: item.certificate.thumbprint()
        });
      };

      return react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.pad, CabucStatusInfo_module_css_1.default.longText)
      }, react_1.default.createElement("p", null, "\u0421 1 \u044F\u043D\u0432\u0430\u0440\u044F 2020 \u0433\u043E\u0434\u0430 \u0432\u0430\u0448 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u0443\u0442\u0440\u0430\u0442\u0438\u043B \u0441\u0442\u0430\u0442\u0443\u0441 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E. \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u043F\u043E\xA0\u0413\u041E\u0421\u0422\xA02012."), react_1.default.createElement(Link_1.Link, {
        onClick: onWhyReissueLinkClick,
        href: CAParams.whyReissueCertOnGost2012In2020Link,
        target: "_blank"
      }, react_1.default.createElement(HelpBook_1.default, null), "\xA0\u0417\u0430\u0447\u0435\u043C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442"), react_1.default.createElement("div", {
        style: {
          marginTop: 18
        }
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: loading,
        onClick: onClick
      }, "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442")));
    };

    _this.NeedNewCertificate = function () {
      var _a = _this.props,
          item = _a.item,
          CAParams = _a.CAParams;

      var render = function render() {
        var text = item.state !== "Expired"
        /* Expired */
        ? react_1.default.createElement("div", null, react_1.default.createElement("p", null, "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u0439\u043C\u0435\u0442 30\xA0\u043C\u0438\u043D\u0443\u0442. \u0412\u043E\xA0\u0432\u0440\u0435\u043C\u044F \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0432\u044B\xA0\u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0441\xA0\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u043C. \u041F\u043E\u0441\u043B\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442."), react_1.default.createElement("p", null, "\u0415\u0441\u043B\u0438 \u043D\u0435\xA0\u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u0434\u043E\xA0\u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0435\u0433\u043E \u0441\u0440\u043E\u043A\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F, \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u0439\u043C\u0435\u0442 \u0434\u043E\xA03\xA0\u0434\u043D\u0435\u0439 \u0438\xA0\u043E\u0442\xA0\u0432\u0430\u0441 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u044E\u0442\u0441\u044F \u0431\u0443\u043C\u0430\u0436\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B.")) : react_1.default.createElement("div", null, react_1.default.createElement("p", null, "\u041C\u044B \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u043C \u0437\u0430\u044F\u0432\u043A\u0443 \u0437\u0430\xA03\xA0\u0434\u043D\u044F"), react_1.default.createElement("p", null, "\u041F\u043E\u0441\u043B\u0435 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043C\u044B\xA0\u043F\u043E\u043F\u0440\u043E\u0441\u0438\u043C \u0432\u0430\u0441\xA0\u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C \u0432\xA0\u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0432\u0430\u0448\u0438\xA0\u0434\u0430\u043D\u043D\u044B\u0435. \u041D\u0430\u043C \u0442\u0430\u043A\xA0\u0436\u0435 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0431\u0443\u043C\u0430\u0436\u043D\u043E\u0435 \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u0435. \u041F\u043E\u0441\u043B\u0435 \u044D\u0442\u043E\u0433\u043E \u043C\u043E\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\xA0\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442."), react_1.default.createElement("p", null, "\u041F\u043E\u0441\u043B\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442."));
        return react_1.default.createElement("div", {
          className: CabucStatusInfo_module_css_1.default.tooltip
        }, text, react_1.default.createElement("p", null, react_1.default.createElement(Link_1.Link, {
          target: "_blank",
          href: CAParams.howToUpdateCertificateLink
        }, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0430\u044F \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F")));
      };

      var loading = _this.state.loading;

      var onClick = function onClick(e) {
        _this.context.trackEvent('certificateAction', 'update', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.onUpdateCertWithCSClick();
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.red)
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: loading,
        onClick: onClick
      }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435")), _this.customTooltip(render));
    };

    _this.processError = function (e) {
      var item = _this.props.item;

      _this.context.trackEvent('certificateAction', 'error', {
        code: e.code,
        thumbprint: item.certificate.thumbprint()
      });

      var onClose = function onClose() {
        return _this.setState({
          modal: null
        });
      };

      switch (e.code) {
        case Errors_2.ErrorCodes.BlockedTabModal:
          {
            _this.setState({
              modal: react_1.default.createElement(Errors_2.BlockedTabModal, {
                onClose: onClose
              })
            });

            break;
          }

        case Errors_2.ErrorCodes.CertificateNotFound:
        default:
          {
            _this.setState({
              modal: react_1.default.createElement(Errors_2.CARequestFail, {
                phone: _this.state.phone,
                onClose: onClose
              })
            });
          }
      }
    };

    _this.VisitRCIsNeccessary = function () {
      var render = function render() {
        return react_1.default.createElement("div", {
          className: CabucStatusInfo_module_css_1.default.tooltip
        }, "\u0411\u0435\u0437 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\xA0\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043C\u044B\xA0\u043D\u0435\xA0\u0441\u043C\u043E\u0436\u0435\u043C \u0432\u044B\u0434\u0430\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442.");
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.green)
      }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430\xA0\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u043D\u044F\u0442\u0430. \u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u0432\xA0\u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440", react_1.default.createElement("span", {
        className: CabucStatusInfo_module_css_1.default.noWrap
      }, " ", _this.state.phone, ", "), "\u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435 \u0438\xA0\u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u0443\u0436\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B"), _this.customTooltip(render));
    };

    _this.Validating = function () {
      var render = function render() {
        return react_1.default.createElement("div", {
          className: CabucStatusInfo_module_css_1.default.tooltip
        }, "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C \u0434\u043E \u0434\u0432\u0443\u0445 \u0434\u043D\u0435\u0439.");
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.gray)
      }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430\xA0\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u0442\u0441\u044F \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u044E\u0449\u0438\u043C \u0446\u0435\u043D\u0442\u0440\u043E\u043C"), _this.customTooltip(render));
    };

    _this.ReadyForRequestGeneration = function () {
      var item = _this.props.item;
      var loading = _this.state.loading;

      var onClick = function onClick(e) {
        _this.context.trackEvent('certificateAction', 'request', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.getUpdateFormUrl(e);
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.message
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.gray
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.green
      }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043F\u0440\u0438\u043D\u044F\u0442\u0430")), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: loading,
        onClick: onClick
      }, "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442")));
    };

    _this.Releasing = function () {
      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.gray)
      }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430\xA0\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u044E\u0449\u0438\u043C \u0446\u0435\u043D\u0442\u0440\u043E\u043C"));
    };

    _this.Released = function () {
      var item = _this.props.item;
      var loading = _this.state.loading;

      var onClick = function onClick(e) {
        _this.context.trackEvent('certificateAction', 'install', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.getUpdateFormUrl(e);
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.message
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.gray
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.green
      }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u0430")), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: loading,
        onClick: onClick
      }, "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442")));
    };

    _this.Rejected = function () {
      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.red)
      }, "\u0417\u0430\u044F\u0432\u043A\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430. ", react_1.default.createElement("br", null), "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u0432\xA0\u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440", ' ', react_1.default.createElement("span", {
        className: CabucStatusInfo_module_css_1.default.noWrap
      }, " ", _this.state.phone, ", "), "\u0447\u0442\u043E\u0431\u044B \u0443\u0437\u043D\u0430\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u043E\u0442\u043A\u0430\u0437\u0430 \u0438 \u0437\u0430\u043D\u043E\u0432\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"));
    };

    _this.EditingInRC = function () {
      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.gray)
      }, "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u0432 \u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442.", ' ', react_1.default.createElement("span", {
        className: CabucStatusInfo_module_css_1.default.noWrap
      }, " ", _this.state.phone, " ")));
    };

    _this.ErrorInVCR = function () {
      var item = _this.props.item;
      var loading = _this.state.loading;

      var onClick = function onClick(e) {
        _this.context.trackEvent('certificateAction', 'fixErrors', {
          thumbprint: item.certificate.thumbprint()
        });

        _this.getUpdateFormUrl(e);
      };

      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.message
      }, !_this.context.wide && react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.gray
      }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", _this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.red
      }, "\u0412 \u0437\u0430\u044F\u0432\u043A\u0435 \u0435\u0441\u0442\u044C \u043E\u0448\u0438\u0431\u043A\u0438, \u0437\u0430\u044F\u0432\u043A\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430")), react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.buttonWrap
      }, react_1.default.createElement(Button_1.Button, {
        use: "primary",
        loading: loading,
        onClick: onClick
      }, "\u0418\u0441\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043E\u0448\u0438\u0431\u043A\u0438")));
    };

    _this.StrangeForms = function () {
      return react_1.default.createElement("div", {
        className: CabucStatusInfo_module_css_1.default.pad
      }, react_1.default.createElement("div", {
        className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.gray)
      }, "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u0432\xA0\u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440", ' ', react_1.default.createElement("span", {
        className: CabucStatusInfo_module_css_1.default.noWrap
      }, " ", _this.state.phone, " ")));
    };

    _this.EmptyResult = function () {
      return react_1.default.createElement("noscript", null);
    };

    _this.getUpdateFormUrl = function (e) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var _a, item, CAParams, useOldCACabinetVersion, error_5, updateUrl, e_3;

        return tslib_1.__generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props, item = _a.item, CAParams = _a.CAParams;
              this.setState({
                loading: true
              });
              useOldCACabinetVersion = false;
              if (!CAParams.doBeforeCertificateUpdate) return [3
              /*break*/
              , 4];
              _b.label = 1;

            case 1:
              _b.trys.push([1, 3,, 4]);

              return [4
              /*yield*/
              , CAParams.doBeforeCertificateUpdate(item)];

            case 2:
              _b.sent();

              return [3
              /*break*/
              , 4];

            case 3:
              error_5 = _b.sent();

              if (error_5 instanceof Errors_1.CommonError && error_5.code === 'ExpiredCertificate') {
                useOldCACabinetVersion = true;
              } else {
                this.setState({
                  loading: false
                }); // все другие ошибки возникшие в doBeforeCertificateUpdate завершают обновление сертификата

                return [2
                /*return*/
                ];
              }

              return [3
              /*break*/
              , 4];

            case 4:
              _b.trys.push([4, 6,, 7]);

              return [4
              /*yield*/
              , CAParams.getUpdateFormUrl(item.statusInfo.newFormId)];

            case 5:
              updateUrl = _b.sent();
              updateUrl = this.changeCabucFormUrl(updateUrl, useOldCACabinetVersion);
              window.location.assign(updateUrl);
              return [3
              /*break*/
              , 7];

            case 6:
              e_3 = _b.sent(); // убираем загрузку если произошла ошибка. Например getUpdateFormUrl зареджектился.

              this.setState({
                loading: false
              });
              this.processError(e_3);
              return [3
              /*break*/
              , 7];

            case 7:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.customTooltip = function (render) {
      return react_1.default.createElement("span", {
        className: CabucStatusInfo_module_css_1.default.helpIcon
      }, react_1.default.createElement(Tooltip_1.Tooltip, {
        render: render,
        pos: "bottom left",
        allowedPositions: ['bottom left', 'bottom right', 'top left', 'top right'],
        trigger: "click"
      }, react_1.default.createElement(HelpDot_1.default, null)));
    };

    var statusInfo = props.item.statusInfo;
    _this.state = {
      phone: statusInfo && statusInfo.rcPhone ? statusInfo.rcPhone : '',
      loading: false,
      modal: null
    };
    return _this;
  }

  CabucStatusInfo.getDerivedStateFromProps = function (props, state) {
    var statusInfo = props.item.statusInfo;
    return tslib_1.__assign(tslib_1.__assign({}, state), {
      phone: statusInfo && statusInfo.rcPhone ? statusInfo.rcPhone : ''
    });
  };

  CabucStatusInfo.prototype.render = function () {
    var item = this.props.item;
    var modal = this.state.modal;
    var result;

    switch (item.statusInfo.status) {
      // Статусы для которых отображаются кнопки ведущие в ЛК Кабуц.
      case shared_1.CabucStatusCode.NeedNewCertificate:
        result = this.NeedNewCertificate();
        break;

      case shared_1.CabucStatusCode.ReadyForRequestGeneration:
        result = this.ReadyForRequestGeneration();
        break;

      case shared_1.CabucStatusCode.Released:
        result = this.Released();
        break;

      case shared_1.CabucStatusCode.ErrorInVCR:
        result = this.ErrorInVCR();
        break;
      // Статусы для которых отображается одинаковый статичный (текстовый) контент

      case shared_1.CabucStatusCode.DoNotNeedUpdate:
      case shared_1.CabucStatusCode.HeraclesDoNotNeedUpdate:
        result = this.EmptyResult();
        break;

      case shared_1.CabucStatusCode.VisitRCIsNeccessary:
      case shared_1.CabucStatusCode.HeraclesVisitRCIsNeccessary:
        result = this.VisitRCIsNeccessary();
        break;

      case shared_1.CabucStatusCode.Validating:
      case shared_1.CabucStatusCode.HeraclesValidating:
        result = this.Validating();
        break;

      case shared_1.CabucStatusCode.Releasing:
      case shared_1.CabucStatusCode.HeraclesReleasing:
        result = this.Releasing();
        break;

      case shared_1.CabucStatusCode.Rejected:
      case shared_1.CabucStatusCode.HeraclesRejected:
        result = this.Rejected();
        break;

      case shared_1.CabucStatusCode.Installed:
      case shared_1.CabucStatusCode.HeraclesInstalled:
        result = this.EmptyResult();
        break;

      case shared_1.CabucStatusCode.EditingInRC:
      case shared_1.CabucStatusCode.HeraclesEditingInRC:
      case shared_1.CabucStatusCode.HeraclesTrialCertificate:
        result = this.EditingInRC();
        break;

      case shared_1.CabucStatusCode.StrangeForms:
      case shared_1.CabucStatusCode.HeraclesStrangeForms:
        result = this.StrangeForms();
        break;
      // Статусы для которых отображаются кнопки ведущие в ЛК Геракла.

      case shared_1.CabucStatusCode.HeraclesNeedNewCertificate:
        result = this.HeraclesNeedNewCertificate();
        break;

      case shared_1.CabucStatusCode.HeraclesReadyForRequestGeneration:
        result = this.HeraclesReadyForRequestGeneration();
        break;

      case shared_1.CabucStatusCode.HeraclesReleased:
        result = this.HeraclesReleased();
        break;

      case shared_1.CabucStatusCode.HeraclesErrorInVCR:
        result = this.HeraclesErrorInVCR();
        break;
      // два новых статуса Геракла

      case shared_1.CabucStatusCode.HeraclesContinueUpdate:
        result = this.HeraclesContinueUpdate();
        break;

      case shared_1.CabucStatusCode.HeraclesFinishUpdate:
        result = this.HeraclesFinishUpdate();
        break;
      // статусы с кнопками для перевыпуска сертов.

      case shared_1.CabucStatusCode.HeraclesReissueCertWithCS:
        result = this.HeraclesReissueCertWithCSIn2020();
        break;

      case shared_1.CabucStatusCode.HeraclesReissueCertWithHeracles:
        result = this.HeraclesReissueCertWithHeraclesIn2020();
        break;

      case shared_1.CabucStatusCode.HeraclesReissueCertWithServiceCenter:
        result = this.HeraclesReissueCertWithServiceCenterIn2020();
        break;

      case shared_1.CabucStatusCode.HeraclesFreeProlongation:
        result = this.HeraclesFreeProlongation();
        break;

      case shared_1.CabucStatusCode.HeraclesReissueActiveCert:
        result = this.HeraclesReissueActiveCert();
        break;
      // перевыпуск сертификатов сторонних УЦ

      case shared_1.CabucStatusCode.HeraclesReissueExternalCACert:
        result = this.HeraclesReissueExternalCACert();
        break;

      case shared_1.CabucStatusCode.HeraclesKStoreProlongation:
        result = this.HeraclesKStoreProlongation();
        break;

      default:
        result = this.EmptyResult();
    }

    return react_1.default.createElement(StopClick, null, modal, result);
  };
  /**
   * Урл на форму в КабУЦ может поменяться из-за результатов выполнения doBeforeCertificateUpdate
   * @param {string} url
   * @param {boolean} useOldCACabinetVersion
   */


  CabucStatusInfo.prototype.changeCabucFormUrl = function (url, useOldCACabinetVersion) {
    return useOldCACabinetVersion ? common_1.addParamsToLink(url, [{
      name: 'oldAuth',
      value: true
    }]) : url;
  };

  CabucStatusInfo.contextType = configuration_1.configurationContext;
  return CabucStatusInfo;
}(react_1.default.Component);

exports.CabucStatusInfo = CabucStatusInfo;

var StopClick = function StopClick(_a) {
  var children = _a.children;

  var stopClickEvent = function stopClickEvent(e) {
    e.stopPropagation();
  };

  return react_1.default.createElement("div", {
    onClick: stopClickEvent,
    onDoubleClick: stopClickEvent
  }, children);
};